import Vue from "vue";

import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json';
window.axios = axios;

import Swal from "sweetalert2";
window.Swal = Swal;

import {errorHandler} from "./errorHandler";
window.errorHandler = errorHandler;

import {dateTimeManager} from "./TimeManager";
window.$dateTimeManager = dateTimeManager;
Vue.prototype.$dateTimeManager = dateTimeManager;

import {utils} from "./utils";
window.$utils = utils;
Vue.prototype.$utils = utils;

import VueGoodTablePlugin from 'vue-good-table';
import "vue-good-table/dist/vue-good-table.css";
Vue.use(VueGoodTablePlugin)


import {responses} from "./responses";
window.responses = responses;


const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3500,
    showCloseButton: true,
    customClass: "toastr",
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

window.pageOptions = {
    enabled: true,
    mode: "pages",
    perPage: 10,
    position: "bottom",
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: "page", // for 'pages' mode
};
window.Toast = Toast;


window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

/**
 * Global Online VSDC toggle and derived API endpoints.
 * - When isOnlineVsdc === true:
 *   - Base host: http://localhost:8282
 *   - portalApi: http://localhost:8282/smartportal/
 *   - SmartInvoiceApi: http://localhost:8282/smartinv/
 *   - LocalServiceApi: disabled (undefined)
 * - When isOnlineVsdc === false:
 *   - Base host: http://localhost:9997
 *   - portalApi: http://localhost:9997/smartportal/
 *   - SmartInvoiceApi: http://localhost:9997/smartinv/
 *   - LocalServiceApi: http://localhost:9090/printing/
 */
window.isOnlineVsdc = true; // Toggle this flag to switch environments

// Compute base host from the toggle
const vsdcBaseHost = window.isOnlineVsdc ? 'https://lna.abc.co.zm' : 'http://localhost:9997';

// Smart Portal API
window.portalApi = `${vsdcBaseHost}/smartportal/`;

// Lyt SI API (left as-is per existing project setup)
// window.lytSIApi = `http://192.168.1.103:8443/smartportal/`
window.lytSIApi = `https://lna.abc.co.zm/lytSI/api/`;

// Smart Invoice API
window.SmartInvoiceApi = `${vsdcBaseHost}/smartinv/`;

// Local Service API — enabled only when NOT in online VSDC mode
if (!window.isOnlineVsdc) {
  window.LocalServiceApi = `http://localhost:9090/printing/`;
} else {
  window.LocalServiceApi = undefined; // disabled in online VSDC mode
}